// extracted by mini-css-extract-plugin
module.exports = {"days":"CalendarDays-days-girjM","day":"CalendarDays-day-1JDzQ","week":"CalendarDays-week-2V9ex","forecast":"CalendarDays-forecast-34LDh","month":"CalendarDays-month-LD-Op"};